export default __webpack_public_path__ + "static/media/request-center-outline-16px.fcf47a9b.svg";